<div class="container mt-4" >
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-th mr-2"></i> Hàng
  </h1>

  <!-- Description Below Title -->
  <p class="lead mb-4">
    Xem và quản lý các hàng trong hệ thống. Nhấn vào "Thêm Hàng" để thêm hàng mới vào danh sách.
  </p>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> Danh Sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
      </a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content" style="background-color: white;">
    <!-- List tab content -->
    <div id="List" class="tab-pane fade show active">
      <div class="container-fluid">
        <!-- Buttons -->
        <button class="btn btn-outline-primary btn-icon-split mb-3" (click)="openAddDialog()">
          <span class="icon text-white-50">
            <i class="fas fa-plus"></i>
          </span>
          <span class="text">Thêm Hàng</span>
        </button>

        <button class="btn btn-outline-secondary btn-icon-split mb-3 ml-2" (click)="refreshData()">
          <span class="icon text-white-50">
            <i class="fas fa-sync-alt"></i>
          </span>
          <span class="text">Làm Mới</span>
        </button>

        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Tìm kiếm theo tên..."
            (input)="updateFilter($event)"
          />
        </div>

        <!-- Loading Indicator -->
        <div *ngIf="loadingIndicator; else loaded">
          <app-loading></app-loading>
        </div> 
        
        <ng-template #loaded>
          <ngx-datatable
            class="bootstrap"
            [rows]="rows"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [reorderable]="reorderable"
            (select)="onSelect($event)"
            (activate)="onActivate($event)">
             
            <ngx-datatable-column name="Tên Phòng Ban" prop="department.departmentName">
              <ng-template ngx-datatable-cell-template let-value="value">
                <span style="color:red;">{{ value }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- Shelf Name Column -->
            <ngx-datatable-column name="Tên Kệ" prop="shelf.shelfName">
              <ng-template ngx-datatable-cell-template let-value="value">
                <span style="color:blue;">{{ value }}</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column *ngFor="let column of columns" [name]="column.name" [prop]="column.prop" [hidden]="!column.visible">
              <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                <ng-container *ngIf="column.name === 'Hành Động'">
                  <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Hành Động
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" (click)="openEditDialog(row)">
                        <i class="fas fa-edit"></i> Chỉnh Sửa
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteRow(row)">
                        <i class="fas fa-trash"></i> Xóa
                      </a>
                    </li>
                  </ul>
                </ng-container>
                <ng-container *ngIf="column.name !== 'Hành Động'">
                  {{ row[column.prop] }}
                </ng-container>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
        </ng-template>
      </div>
    </div>

    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div>
         <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>
  </div>
</div>
